import {Component, OnInit, AfterViewInit, ElementRef, ViewChild} from "@angular/core";
import {User} from "../../definitions";
import {E_NAV_NODE_TYPE, INavigationEntries, nav_createNavigation} from "../../helpers/navigation-utils";
import {AuthService} from "../../services/auth.service";
import {Router} from "@angular/router";
import { environment } from '../../../environments/environment';
import {Title} from "@angular/platform-browser";
import {setFavicon} from "../../utils";
import {localeUtils} from "../../helpers/locale-utils";
import {paramsHelper} from "../../helpers/params-helper";
import {DOCUMENT_TYPES} from "../../enums/enums";
import {CollectionService} from "../../services/collection.service";

declare const __apiVer: any;
declare const __appName: any;
declare const __appIsProd: any;


@Component({
  templateUrl: "./main-page.component.html"
})


export class MainPageComponent implements OnInit, AfterViewInit {
  E_NAV_NODE_TYPE = E_NAV_NODE_TYPE;
  API_VER = __apiVer;
  APP_NAME = __appName;
  APP_IS_PROD = __appIsProd;
  links: INavigationEntries = [];
  localeUtils = localeUtils;
  loadedLocales:any[]  = [];
  
  @ViewChild("headerElement") headerElement:ElementRef;
  @ViewChild("contentElement") contentElement:ElementRef;

  NESTED: number = 1;
  PLAIN: number = 0;
  user: User;

  prodStyle:boolean = false;
  draftStyle:boolean = false;

  constructor(private _authService: AuthService,
              private collectionService:CollectionService,
              private router:Router,
              private title:Title) {
    if (this.APP_IS_PROD) {
      this.prodStyle = true;
      setFavicon();
    }
    this.draftStyle = (this.APP_NAME == "draft-adm" || this.APP_NAME == "my-local");
    title.setTitle(`${this.APP_NAME} (API:${this.API_VER})`);
  }


  ngOnInit():void {
    this.getUserInfo();
    this.links = nav_createNavigation(this.router.config);
    this.loadLocalesList();
  }
  
  ngAfterViewInit():void {
    this.fixContentPadding();
  }

  getUserInfo() {
    this._authService.authenticated()
      .subscribe((user: User) => {
      this.user = user;
      //console.log(user);
    });
  }

  onLocaleChange(event){
    localeUtils.setLocale(event);
    window.location.reload();
  }

  private loadLocalesList()
  {
    const params = paramsHelper
      .loader()
      .setEndpointApi()
      .setObjectType(DOCUMENT_TYPES.LOCALE)
      .setNavParams(0, 9999);

    this.collectionService.loadChunkCached(params)
      .subscribe(r => {
        this.loadedLocales = r.documents;
        this.loadedLocales = this.loadedLocales.filter(loc => loc.disabled != true);
      })
  }
  
  onResize(event):void {
    this.fixContentPadding();
  }
  
  fixContentPadding():void {
    this.contentElement.nativeElement.style.paddingTop = this.headerElement.nativeElement.offsetHeight + "px";
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/main/main-page.component.ts